import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { Grid, CircularProgress } from '@mui/material';
import { send_request } from '../../../utils/Request';
import ErrorIcon from '@mui/icons-material/Error';
import HandleJsonFunction from '../../Component/HandleJsonFunction';
import InZapierOrW86Box from './InZapierOrW86Box';

class SendSampleFromZapier extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: false,
      errorMessage: '',
      status: '',
      pollingInterval: null,
    };
  }

  selectMethod = value => {
    this.setState({
      method: value,
    });
  };

  setSamplingStatus = async (projectId, componentId) => {
    send_request(
      `project-service/project/set-sampling-status/${projectId}/${componentId}`,
      '',
      '',
      'PATCH'
    )
      .then(response => {
        if (response && response.status === 200) {
          this.setState({
            status: 'SAMPLING',
          });
        }
      })
      .catch(err => {
        throw err;
      });
  };

  componentDidMount = () => {
    this.setSamplingStatus(this.props.project_id, this.props.component_id);
    this.startPollingForSample(this.props.component_id, this.props.version);
  };

  componentWillUnmount = () => {
    if (this.state.pollingInterval) {
      clearInterval(this.state.pollingInterval);
    }
  };

  startPollingForSample = (component_id, version) => {
    // Clear any existing polling interval first
    if (this.state.pollingInterval) {
      clearInterval(this.state.pollingInterval);
    }

    const interval = setInterval(() => {
      if (
        !this.state.loading &&
        this.state.status === 'SAMPLING' &&
        !this.props.componentStore.data.json
      ) {
        this.getSample(component_id, version);
      } else if (this.props.componentStore.data.json) {
        clearInterval(interval);
        this.setState({ pollingInterval: null });
      }
    }, 3000);

    this.setState({ pollingInterval: interval });

    // Set timeout to stop polling after 30 seconds
    setTimeout(() => {
      if (this.state.pollingInterval === interval) {
        clearInterval(interval);
        this.setState({ pollingInterval: null });
        if (!this.props.componentStore.data.json) {
          this.setState({
            loading: false,
            error: true,
            errorMessage:
              'Automatic polling for sample has timed out. Please try again by sending another sample from Zapier and clicking "Try Again".',
          });
        }
      }
    }, 30 * 1000);

    // Initial call to get sample
    this.getSample(component_id, version);
  };

  getSample = async (component_id, version) => {
    this.setState({ error: false, loading: true });

    send_request(
      'project-service/project/component/query/' + component_id + '/at-version/' + version,
      '',
      {}
    )
      .then(response => {
        if (response && response.data) {
          const { components } = response.data;
          if (components && components.length > 0) {
            if (components[0].componentData && components[0].componentData.sample) {
              const sample = components[0].componentData.sample;
              try {
                // Validate the sample is proper JSON
                const sampleJson = typeof sample === 'string' ? JSON.parse(sample) : sample;

                // Update the componentStore with the sample
                this.props.componentStore.setField(JSON.stringify(sampleJson), '', 'sample');

                // Update state and clear polling
                this.setState({ error: false, loading: false });

                if (this.state.pollingInterval) {
                  clearInterval(this.state.pollingInterval);
                  this.setState({ pollingInterval: null });
                }

                // Move to next step
                this.props.onChangeState(3, 3);
              } catch (err) {
                this.setState({
                  error: true,
                  loading: false,
                  errorMessage: 'Error with sample: ' + err.message,
                });
              }
            } else {
              this.setState({
                error: false,
                loading: false,
                errorMessage:
                  'A sample was not received. Please try again by sending another sample from Zapier',
              });
            }
          } else {
            this.setState({
              error: false,
              loading: false,
              errorMessage: 'No component data found',
            });
          }
        } else {
          this.setState({
            error: false,
            loading: false,
            errorMessage: 'No response data received',
          });
        }
      })
      .catch(err => {
        this.setState({
          error: true,
          loading: false,
          errorMessage:
            'Error fetching sample: ' +
            (err.message || 'Please try again by sending another sample from Zapier'),
        });
      });
  };

  render() {
    let zapierContent = (
      <Grid container spacing={2} style={{ padding: '16px' }}>
        <Grid item xs={12} className="textAlignCenter">
          1. In Zapier, go to the <b>Test action</b> step
        </Grid>

        <Grid item xs={12} className="textAlignCenter">
          <img
            src="/images/trigger_from_zapier_sample.png"
            style={{
              border: 'thin solid #C4C4C4',
              borderRadius: '10px',
              boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
              width: '80%',
              height: 'auto',
            }}
          />
        </Grid>

        <Grid item xs={12} className="textAlignCenter">
          2. Click <b>Test & Continue</b>
        </Grid>
      </Grid>
    );

    let workflow86Content = (
      <Grid container spacing={2} style={{ padding: '16px' }}>
        <Grid item xs={12} className="textAlignCenter">
          3. We're automatically scanning for your sample data...
        </Grid>
      </Grid>
    );

    return (
      <Grid container spacing={2}>
        <InZapierOrW86Box
          zapierOrW86={'Zapier'}
          content={zapierContent}
          isExpanded={this.props.isExpanded}
        />

        <InZapierOrW86Box
          zapierOrW86={'Workflow86'}
          content={workflow86Content}
          isExpanded={this.props.isExpanded}
        />

        {this.state.error && (
          <Grid item xs={12} className="textAlignCenter">
            <p className="err-text">
              <ErrorIcon className="iconDiscard" />
              {this.state.errorMessage}
            </p>
          </Grid>
        )}

        <Grid item xs={12} className="dialogContentRight">
          <Grid item xs={12}>
            <Button
              onClick={() => {
                this.props.onChangeState(1, 1);
              }}
              className="btnSpace"
              variant={'outlined'}
              color={'info'}
            >
              {' '}
              Back
            </Button>

            {this.props.componentStore.data.json !== '' && (
              <Button
                onClick={() => {
                  this.props.onChangeState(3, 3);
                }}
                className="btnSpace"
                variant={'outlined'}
                color={'info'}
              >
                {' '}
                Skip
              </Button>
            )}

            {this.state.status == 'SAMPLING' ? (
              <Button
                onClick={() => {
                  if (this.state.pollingInterval) {
                    clearInterval(this.state.pollingInterval);
                    this.setState({ pollingInterval: null });
                  }
                  this.getSample(this.props.component_id, this.props.version);
                  this.startPollingForSample(this.props.component_id, this.props.version);
                }}
                variant={'contained'}
                color={'primary'}
                disabled={this.state.loading}
              >
                {' '}
                {this.state.error
                  ? 'Try Again'
                  : this.state.loading
                  ? 'Loading...'
                  : this.state.pollingInterval
                  ? 'Searching for sample...'
                  : 'Check for Sample Now'}
                {this.state.loading || this.state.pollingInterval ? (
                  <CircularProgress size={24} className="buttonProgress" />
                ) : null}
              </Button>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default SendSampleFromZapier;
